import { Outlet, createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/fundamentals')({
  component: Outlet,
})
